// src/pages/AccessDenied/roleRoutePermissions.js
// Sistema temporal de control de acceso por rol.
// Cuando el backend de permisos este listo, reemplazar por PermissionsContext.

/**
 * Rutas bloqueadas temporalmente para TODOS los roles (incluyendo admin).
 * Remover de esta lista cuando el modulo este listo.
 */
const BLOCKED_ROUTES = [];

/**
 * Rutas accesibles para todos los roles autenticados.
 */
const UNIVERSAL_ROUTES = [
  "/Main",
  "/main",
  "/profile",
  "/patient-profiles",
  "/support",
  "/Login",
  "/Unauthorized",
  "/AccessDenied",
  "/library",
];

/**
 * Configuracion de permisos por rol.
 * - allowAll: true  => acceso total (admin)
 * - routes: []      => lista de prefijos de ruta permitidos
 */
const ROLE_PERMISSIONS = {
  // Admin — acceso total
  "1": {
    allowAll: true,
  },
  // PCP — Clinical + patient routes
  "2": {
    routes: [
      "/coding-opportunities",
      "/CoddingOpportunities",
      "/care-gaps",
      "/CareGap",
      "/patient-map",
      "/PatientMap",
      "/patientMap",
      "/patient-detail",
      "/ClinicalInfo",
      "/clinicalInfo",
      "/clinical-info",
      "/specialist-referrals",
      "/LabPhlebotomy",
      "/ClinicalNoteAi",
      "/clinical-notes",
      "/assignments",
    ],
  },
  // Care Management — Care Management + patient routes
  "3": {
    routes: [
      "/care-gaps",
      "/CareGap",
      "/Careplan",
      "/patient-map",
      "/PatientMap",
      "/patientMap",
      "/patient-detail",
      "/ClinicalInfo",
      "/clinicalInfo",
      "/clinical-info",
      "/specialist-referrals",
      "/ClinicalNoteAi",
      "/clinical-notes",
    ],
  },
  // CEO — acceso total
  "4": {
    allowAll: true,
  },
};

/**
 * Verifica si un rol tiene acceso a una ruta determinada.
 * Usa prefix matching para manejar rutas dinamicas (ej: /coding-opportunities/patient/123).
 *
 * @param {string|number} userRol - Rol del usuario (viene de user.rol)
 * @param {string} pathname - Ruta actual (location.pathname)
 * @returns {boolean}
 */
export const canRoleAccessRoute = (userRol, pathname) => {
  // Rutas bloqueadas temporalmente: nadie puede acceder
  const isBlocked = BLOCKED_ROUTES.some(
    (route) => pathname === route || pathname.startsWith(route + "/")
  );
  if (isBlocked) return false;

  // Rutas universales: accesibles para todos
  const isUniversal = UNIVERSAL_ROUTES.some(
    (route) => pathname === route || pathname.startsWith(route + "/")
  );
  if (isUniversal) return true;

  const rolKey = String(userRol);
  const config = ROLE_PERMISSIONS[rolKey];

  // Rol no definido en config => denegar por defecto
  if (!config) return false;

  // Admin: acceso total
  if (config.allowAll) return true;

  // Verificar con prefix matching
  return config.routes.some(
    (route) => pathname === route || pathname.startsWith(route + "/")
  );
};
